










import { Component, Vue } from 'vue-property-decorator'
import { Button, Card } from '@alpha/ink'
import SettingsInput from '@/components/SettingsInput.vue'
import ConfirmationMessage from '@/components/ConfirmationMessage.vue'
import PasswordSection from '@/components/PasswordSection.vue'
import AjaxButton from '@/components/AjaxButton.vue'

@Component({
  components: { Card, Button, SettingsInput, ConfirmationMessage, PasswordSection, AjaxButton }
})

export default class PersonalSettings extends Vue {}
